import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';
import { BooleanParam, useQueryParam } from 'use-query-params';

import { eventListConstants, eventListModels } from '..';

export const useActivityLogsFilter = (
  props: {
    page?: number;
    size?: number;
    startDate?: string | null;
    finishDate?: string | null;
    responsibleByIds?: number[] | null;
    objectType?: string | null;
    actionTypes?: string[] | null;
    objectStartDate?: string | null;
    objectFinishDate?: string | null;
    previous?: string | null;
    current?: string | null;
    currentTags?: string[] | null;
    previousTags?: string[] | null;
    clientIds?: number[] | null;
    currentStatuses?: number[] | null;
    previousStatuses?: number[] | null;
    enabled?: boolean;
    partTwoFilter?: object;
  } = {}
) => {
  const { enabled, ...body } = props;
  const [isSecondStep] = useQueryParam('isSecondStep', BooleanParam);

  return useQuery<Pagination<eventListModels.IActivityLog>>({
    queryKey: [eventListConstants.queryKeys.ACTIVITY_LOGS_FILTER, isSecondStep, body],
    queryFn: async () => {
      const res = await $api?.post('/v1/activity-logs/filter', {
        ...body,
        startDate: body.startDate?.slice(0, 10),
        finishDate: body.finishDate?.slice(0, 10)
      });

      const data: Pagination<eventListModels.IActivityLog> = res?.data?.data;

      return {
        ...data,
        data: data?.data?.map(item => ({
          ...item,
          createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
        }))
      };
    },
    enabled
  });
};
